@let obs =
  {
    isLoading: isLoading$ | async,
    banners: bannerOneRows$ | async,
  };

@if (obs.banners) {
  <div class="banner-rows container-v2">
    @for (banner of obs.banners; track banner.url) {
      <div
        class="banner-row-item"
        [sdInViewport]="0.5"
        [intersectedOnce]="true"
        (intersected)="onBannerIntersect(banner)"
        (click)="onBannerClick(banner)"
      >
        <sd-generic-link [url]="banner.link">
          <img [ngSrc]="banner.url" [alt]="banner.altText" fill />
        </sd-generic-link>
      </div>
    }
  </div>
} @else if (obs.isLoading) {
  <div class="banner-rows container-v2 sd-group-skeleton-gradient-wave">
    @for (i of [].constructor(numberOfSkeletons$ | async); track $index) {
      <div class="banner-row-item sd-skeleton"></div>
    }
  </div>
}
